module.exports = __webpack_public_path__ + "static/img/artist-joey@2x.7464a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artist/artist-joey@2x.png
// module id = xPQX
// module chunks = 12